import { Subject } from 'rxjs';

interface LogEvent {
    error: Error;
    additionalInfo?: string;
}

export const errorLogSubject = new Subject<LogEvent>();

export function publishErrorEvent(error: Error, additionalInfo?: string): void {
    errorLogSubject.next({
        error,
        additionalInfo,
    });
}

/**
 * Use only for logger service
 */
export const errorLogObservable = errorLogSubject.asObservable();
